module.exports = __webpack_public_path__ + "assets/header_logo_small.adbbce3a.svg";